<template>
  <div id="unanswered">
    <div class="wrap">
      <popups text="未解答原因" anonymous="hide" @confirm="confirm" @onOff="$emit('onOff', 'unanswered')">
        <div class="reason-list">
          <div class="reason-item" v-for="(reason, index) in reasonList" :key="reason.id" @click="selectReason(index)">
            <div class="reason-text">{{ reason.text }}</div>
            <div class="reason-selected" :class="[reason.selected ? 'reason-selected-active' : '']"></div>
          </div>
        </div>
        <div class="reason-content">
          <textarea :placeholder="prompt" v-model.trim="reasonMessage"></textarea>
        </div>
      </popups>
    </div>
  </div>
</template>

<script>
import popups from '../popups/popups'

export default {
  name: 'unanswered',
  data () {
    return {
      prompt: '请输入具体原因',
      reasonList: [
        {id: 1, text: '回答不清晰', selected: false},
        {id: 2, text: '操作后未解决', selected: false},
        {id: 3, text: '其他', selected: false}
      ],
      reasonMessage: '',
      reasonType: 0
    }
  },
  components: {
    popups
  },
  methods: {
    selectReason (n) {
      let self = this
      this.reasonList.forEach((item, index) => {
        if (index === n) {
          item.selected = true
          self.reasonType = item.id
        } else {
          item.selected = false
        }
      })
    },
    confirm () {
      if (this.reasonType === 0) {
        this.$message({
          showClose: true,
          message: '您还未选择原因',
          type: 'warning'
        })
        return
      }
      if (this.reasonType !== 0) {
        let reason = {
          unsolvedType: this.reasonType,
          unsolvedReason: this.reasonMessage
        }
        this.$emit('confirm', reason, 'unanswered')
      }
    }
  }
}
</script>

<style scoped>
  ::-webkit-input-placeholder { /* WebKit browsers */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  ::-moz-placeholder { /* Mozilla Firefox 19+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }

  :-ms-input-placeholder { /* Internet Explorer 10+ */
    font-size: 15px;
    color: #CCCCCC;
    letter-spacing: 0;
  }
  #unanswered {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
  }

  .wrap {
    box-sizing: border-box;
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 1000;
    transform: translate(-50%, -50%);
    width: 580px;
    height: 526px;
    padding: 38px 40px;
    background: #fff;
  }

  .reason-list {
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    height: 128px;
    margin-top:40px;
  }
  .reason-item {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 24px;
    font-size: 17px;
    color: #333333;
    line-height: 24px;
    letter-spacing: 0;
    cursor: pointer;
  }
  .reason-text {

  }
  .reason-selected {
    width: 18px;
    height: 18px;
    border: 1px solid #ccc;
    border-radius: 50%;
  }
  .reason-selected-active {
    background: url("../../icons/selected.svg") no-repeat;
  }

  .reason-content {
    margin: 19px 0 38px;
  }
  .reason-content textarea {
    box-sizing: border-box;
    width: 500px;
    height: 180px;
    padding: 15px 12px;
    border: 1px solid #ccc;
    resize: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/unanswered/unanswered.vue